import { render, staticRenderFns } from "./ExportWord.vue?vue&type=template&id=f5316eda"
import script from "./ExportWord.vue?vue&type=script&lang=js"
export * from "./ExportWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports